export default "__VITE_ASSET__B88wCgMz__"